import { EventEmitter } from '@angular/core';
import { FileInput } from '../../../src/app/@types';
import { EStaticFileType, StaticUploadRequest } from '../../../src/app/@shared-types/misc/file';
import { FileService } from '../../../shared/storage/file.service';

/* @ngInject */
export default class StaticUploadController {
  // public uploaded: EventEmitter<string | null>;

  public exit!: (event: { $event: string | null }) => void;

  public identifier!: string;

  private fileService: FileService;

  public uploads: { static: FileInput } = {
    static: {} as FileInput,
  };

  public sending = false;

  constructor(
    fileService: FileService,
  ) {
    this.fileService = fileService;
  }

  public upload = async (): Promise<void> => {
    if (!this.uploads.static.file) return;

    this.sending = true;

    const uploadReq: StaticUploadRequest = {
      identifier: this.identifier,
      type: EStaticFileType.TEMPLATE_APPENDIX,
    };

    const staticId = await this.fileService
      // eslint-disable-next-line max-len
      .apiUploadStatic(this.uploads.static.file, uploadReq, this.uploads.static.file.progressBar);

    this.exit({ $event: staticId });
  };

  public abort = (): void => {
    // this.uploaded.emit(null);
    this.exit({ $event: null });
  };
}
